module.exports = __webpack_public_path__ + "img/essg3.13a3c392.jpg";